interface IconProps {
  color?: string
}

export const Smile = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4.86615C9.8512 4.86615 4.86663 9.85071 4.86663 15.9995C4.86663 22.1482 9.8512 27.1328 16 27.1328C22.1487 27.1328 27.1333 22.1482 27.1333 15.9995C27.1333 9.85071 22.1487 4.86615 16 4.86615ZM3.1333 15.9995C3.1333 8.89341 8.8939 3.13281 16 3.13281C23.106 3.13281 28.8666 8.89341 28.8666 15.9995C28.8666 23.1055 23.106 28.8661 16 28.8661C8.8939 28.8661 3.1333 23.1055 3.1333 15.9995Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6404 18.1456C20.9276 17.7632 21.4706 17.6858 21.8533 17.9728C22.2362 18.26 22.3138 18.8032 22.0266 19.1861L21.3333 18.6661C22.0266 19.1861 22.0269 19.1859 22.0266 19.1861L22.0257 19.1874L22.0246 19.1888L22.0219 19.1924L22.0141 19.2026L21.9895 19.234C21.9692 19.2597 21.9408 19.2948 21.9047 19.3379C21.8325 19.424 21.7286 19.5424 21.5944 19.6825C21.3268 19.9618 20.9342 20.331 20.4264 20.7004C19.414 21.4367 17.9054 22.1995 16 22.1995C14.0945 22.1995 12.5859 21.4367 11.5736 20.7004C11.0657 20.331 10.6731 19.9618 10.4055 19.6825C10.2713 19.5424 10.1675 19.424 10.0952 19.3379C10.0591 19.2948 10.0308 19.2597 10.0104 19.234L9.98584 19.2026L9.97806 19.1924L9.9753 19.1888L9.97421 19.1874C9.97399 19.1871 9.9733 19.1861 10.6666 18.6661L9.9733 19.1861C9.68611 18.8032 9.76372 18.26 10.1466 17.9728C10.5293 17.6858 11.0721 17.7631 11.3594 18.1454L11.3694 18.1581C11.38 18.1715 11.3979 18.1937 11.4229 18.2236C11.4731 18.2833 11.5515 18.3732 11.6569 18.4832C11.8685 18.7039 12.1842 19.0013 12.593 19.2986C13.414 19.8956 14.5721 20.4661 16 20.4661C17.4278 20.4661 18.5859 19.8956 19.4069 19.2986C19.8157 19.0013 20.1315 18.7039 20.343 18.4832C20.4484 18.3732 20.5269 18.2833 20.577 18.2236C20.6021 18.1937 20.6199 18.1715 20.6305 18.1581L20.6404 18.1456Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M13.3333 13.3328C13.3333 14.0692 12.7363 14.6661 12 14.6661C11.2636 14.6661 10.6666 14.0692 10.6666 13.3328C10.6666 12.5964 11.2636 11.9995 12 11.9995C12.7363 11.9995 13.3333 12.5964 13.3333 13.3328Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M21.3333 13.3328C21.3333 14.0692 20.7363 14.6661 20 14.6661C19.2636 14.6661 18.6666 14.0692 18.6666 13.3328C18.6666 12.5964 19.2636 11.9995 20 11.9995C20.7363 11.9995 21.3333 12.5964 21.3333 13.3328Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
